/**
 * CS: Drawer-first navigation — click interception + Escape support
 * Desktop menu items with submenus open the side drawer instead of
 * mega-menu dropdowns. Uses document-level event delegation (morph-safe).
 *
 * How it works:
 * 1. Click handler: intercepts clicks on menu links with aria-haspopup,
 *    sets details.open = true (renders drawer content), then calls
 *    drawer.open() for animation classes.
 * 2. Auto-expand: after opening, the matching accordion section inside the
 *    drawer is expanded so sub-links are immediately visible.
 * 3. Escape handler: Horizon's built-in keyup listener is on <header-drawer>
 *    (not document), so Escape only works when focus is inside the drawer.
 *    We add a document-level handler so Escape always closes the drawer.
 */
(function () {
  /* ── Open drawer on menu link click ── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('header-menu .menu-list__link[aria-haspopup]');
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();

    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;

    var details = drawer.querySelector('details');
    if (!details) return;

    var clickedText = link.textContent.trim();

    // Step 1: Tell the browser to render the <details> content
    details.open = true;

    // Step 2: Close search panel if open — mutual exclusivity prevents z-index stacking conflict
    const searchPanel = document.querySelector('cs-search-panel');
    if (searchPanel && typeof searchPanel.close === 'function') {
      searchPanel.close();
    }

    // Step 3: Let Horizon's open() add animation classes (menu-open, aria, focus trap)
    if (typeof drawer.open === 'function') {
      drawer.open();
    }

    // Step 4: Auto-expand the matching accordion section
    requestAnimationFrame(function () {
      var summaries = drawer.querySelectorAll('.menu-drawer__menu-item--mainlist');
      for (var i = 0; i < summaries.length; i++) {
        var summary = summaries[i];
        if (summary.tagName !== 'SUMMARY') continue;
        var parentDetails = summary.closest('details');
        if (!parentDetails) continue;

        if (summary.textContent.trim() === clickedText) {
          parentDetails.open = true;
        } else {
          parentDetails.open = false;
        }
      }
    });
  });

  /* ── Close search panel when drawer opens (covers mobile hamburger + desktop) ── */
  document.addEventListener('toggle', function (e) {
    const details = e.target.closest('#Details-menu-drawer-container');
    if (!details || !details.open) return;

    const searchPanel = document.querySelector('cs-search-panel');
    if (searchPanel && typeof searchPanel.close === 'function') {
      searchPanel.close();
    }
  }, true);

  /* ── Close drawer on Escape (document-level, covers all focus states) ── */
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;

    var drawer = document.querySelector('header-drawer');
    if (drawer && drawer.isOpen && typeof drawer.close === 'function') {
      drawer.close();
    }
  });
})();
